import { WithStyles, withStyles } from '@mui/styles';
import { FirmRecord } from '@tassat/fred-definitions';
import { WalletRecordExtended } from '@tassat/fred-extended-definitions';
import { RouteComponentProps } from 'react-router-dom';

import { FirmWalletUsers } from './firmWalletUsers';
import { muiStyles } from './styles';

type RouteParams = {
    accountId: string;
};

export interface FirmWalletUsersProps extends RouteComponentProps<RouteParams>, WithStyles<typeof muiStyles> {
    firm: FirmRecord;
    wallet: WalletRecordExtended;
}

export default withStyles(muiStyles)(FirmWalletUsers);